export default __webpack_public_path__ + "static/media/paralax.0aac183f.png";